// Source-shader registry (D15): a fill's `source: 'shader:<name>'` selects one; its values live in `source_settings[source]` (~/lib/sourceSettings). Shaders are auto-discovered data modules; generate via `scripts/shader-import.mjs`.

import SHADERS, { registerShaders } from './registry'

const logger = console.scope('shaders')

export {
	getShader,
	getShaderDefaults,
	isPathed,
	isShaderSource,
	isShipped,
	onShadersChanged,
	registerShaders,
	SHADER_NAMES,
	SHADER_PREFIX,
	shaderRegistryVersion,
} from './registry'

export {
	advanceTrail,
	boundParams,
	buildFragment,
	clockAt,
	drawShaderFrame,
	frameUniforms,
	heldIds,
	heldParamsOf,
	heldUniforms,
	hexToRgb01,
	integratedAt,
	integratedParamsOf,
	integrateInto,
	isColorParam,
	isSubset,
	liveRateUniform,
	lockUniforms,
	perUnit,
	PIPELINE,
	pipelineVariant,
	previewUniforms,
	rateBaseOf,
	rateUniformOf,
	palettePath,
	rgb01ToHex,
	stageUnit,
	steadyTrail,
	SURFACE_VERTEX,
	surfaceFragment,
	THUMB_TIME,
	thumbUniforms,
	TRAIL_AT,
	trailOf,
	trailUniform,
	turnsUniform,
	uniformName,
	uniformValue,
	variantOf,
	VERTEX,
	wrapCycle,
} from './common'

const library = import.meta.glob(['./*.js', '!./index.js', '!./common.js', '!./registry.js', '!./vocab.js'], {
	eager: true,
})
// The generator's modules play on the dev server only: vitest and a build see the library alone.
const generated =
	import.meta.env.DEV && import.meta.env.MODE !== 'test'
		? import.meta.glob('/local/shader-gen/*.js', { eager: true })
		: {}
const changed = registerShaders({ ...library, ...generated })

if (import.meta.hot) {
	import.meta.hot.accept()
	if (changed.length) logger.info('hot swap', changed)
}

// Thumbs ship in the app build: Vite content-hashes each jpg, so a re-shoot busts the cache and a deleted file leaves nothing behind.
const THUMB_URLS = import.meta.hot?.data?.thumbs ?? {}
if (import.meta.hot?.data) import.meta.hot.data.thumbs = THUMB_URLS
for (const key of Object.keys(THUMB_URLS)) delete THUMB_URLS[key]
for (const [file, url] of Object.entries(
	import.meta.glob('/shaders/thumbs/*.jpg', { eager: true, query: '?url', import: 'default' })
))
	THUMB_URLS[file.slice(file.lastIndexOf('/') + 1, -4)] = url

/** URL of a shader's thumbnail (`shaders/thumbs/<name>.jpg`, captured by scripts/shader-thumbs.mjs); null when none (icon fallback). */
export const shaderThumbUrl = name => THUMB_URLS[name] ?? null

export default SHADERS
